import "./user_management.scss";
import Swal from "sweetalert2";
import { showSwalSuccess, showSwalError } from "../../../utils/swal";
import axios from "axios";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import { showSwalQuestion } from "../../../utils/swal";
import Helmet from "react-helmet";
import sendRequest from "hooks/useAxios";

import Modals from "./Modals";
import React, { useEffect, useState, useContext } from "react";

import Filter from "./Filter";
import PersonnelTab from "./PersonnelTab";
import CustomerTab from "./CustomerTab";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import Loader from "utils/Loader";
import UserInfoModal from "common/UserModal";

export default function UserManagement({ logo }) {
  // const [Users, setUsers] = useState(false);
  const [loading, setLoading] = useState(true);
  const [UpdaterModal, setUpdaterModal] = useState(true);
  const [breakmg, setBreakmg] = useState(false);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [filteredPersonel, setFilteredPersonel] = useState([]);
  const [chosenCustomers, setChosenCustomers] = useState([]);
  const [chosenPersonel, setChosenPersonel] = useState([]);
  const [countCustomers, setCountCustomers] = useState("");
  const [countPersonal, setCountPersonal] = useState("");
  const [tags, settags] = useState([]);
  const [Access, setAccess] = useState([]);
  const [Tab, setTab] = useState(1);
  const [Citys, setCitys] = useState([]);
  const [UserAccess, setUserAccess] = useState([]);
  const [FirstAccess, setFirstAccess] = useState([]);
  const [FilterKey, setFilterKey] = useState(false);
  const [id, setId] = useState("");
  const [dates, setDates] = useState([]);
  const [filter, setFilter] = useState({
    user_type: "",
    fname: "",
    lname: "",
    mobile: "",
    codemelli: "",
    frommtm: "",
    tomtm: "",
    mainstatus: "",
    user_tags_ids: "",
  });

  const [Updater, setUpdater] = useState(false);
  const [SelectedUserInformation, setSelectedUserInformation] = useState({});
  const auth = useContext(WithAuthentication);
  const [pagination, setpagination] = useState(0);
  const [pagination2, setpagination2] = useState(0);

  function deleteUser(id) {
    showSwalQuestion("آیا از حذف کاربر مطمئن هستید؟").then((result) => {
      if (result.isConfirmed) {
        sendRequest("Delete_users", { conditions: `id/=/${id}` })
          .then(({ data }) => {
            if (!(data.status == 1)) {
              Swal.fire("مشکلی در حذف کاربر پیش آمده است", "", "warning");
            }
            if (data.status == 1) {
              showSwalSuccess(" حذف کاربر با موفقیت انجام شد");
              setUpdater(!Updater);
            }
          })
          .catch((error) => {});
      }
    });
    // Swal.fire({
    //   title: "کاربر مد نظر حذف شود؟",
    //   text: "این عمل برگشت پذیر نیست",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#3085d6",
    //   cancelButtonColor: "#d33",
    //   confirmButtonText: "بله",
    //   cancelButtonText: "خیر",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     let formData = new FormData();
    //     formData.append("edit_key", edit_key);
    //     sendRequest("deleteuser", formData).then(({ data }) => {
    //       if (data.state == 1) {
    //         Swal.fire("کاربر با موفقیت حذف شد", "", "success");
    //         setUpdater(!Updater);
    //       } else {
    //         Swal.fire("مشکلی در حذف کاربر پیش آمده است", "", "warning");
    //       }
    //     });
    //   }
    // });
  }

  function changeStatus(id, nextStatus, isadmin) {
    if (id.length == 1) {
      let text =
        nextStatus == 2
          ? "آیا از مسدود کردن کاربر مطمئن هستید؟"
          : "آیا از فعال کردن کاربر مطمئن هستید؟";
      showSwalQuestion(text).then((result) => {
        if (result.isConfirmed) {
          sendRequest("Update_users", {
            keyvalues: `mainstatus,${nextStatus}`,
            conditions: `id/=/${id[0]}`,
          })
            .then(({ data }) => {
              if (!(data.status == 1)) {
                Swal.fire(
                  "مشکلی در تغییر وضعیت کاربر پیش آمده است",
                  "",
                  "warning"
                );
              }
              if (data.status == 1) {
                setUpdater(!Updater);
                showSwalSuccess("تغییر وضعیت کاربر با موفقیت انجام شد");
              }
            })
            .catch((error) => {});
        }
      });
    } else {
      let breaK = true;
      let text =
        nextStatus == 2
          ? "آیا از مسدود کردن کاربران مطمئن هستید؟"
          : "آیا از فعال کردن کاربران مطمئن هستید؟";

      showSwalQuestion(text).then((result) => {
        if (result.isConfirmed) {
          id.map((item) => {
            let form = new FormData();
            form.append("keyvalues", `mainstatus,${nextStatus}`);
            form.append("conditions", `id/=/${item[0]}`);
            sendRequest("Update_users", form)
              .then(({ data }) => {
                if (data.status == 1) {
                  showSwalSuccess("تغییر وضعیت کاربران با موفقیت انجام شد");
                  setUpdater(!Updater);
                } else {
                  if (breaK) {
                    breaK = false;
                    Swal.fire(
                      "مشکلی در تغییر وضعیت تعدادی از کاربران پیش آمده است",
                      "",
                      "warning"
                    );
                  }
                }
              })
              .catch((error) => {});
          });
        }
      });
    }
  }

  const Update = (info) => {
    const Check = (value) => {
      if (value == undefined || value == null) {
        return "";
      } else {
        return value;
      }
    };
    let form = new FormData();
    form.append(
      "updateValue",
      `fname,${Check(info.fname)}@@lname,${Check(info.lname)}@@type,${Check(
        info.type
      )}@@mobile,${Check(info.mobile)}@@codemeli,${Check(
        info.codemell
      )}@@address,${Check(info.address)}
      `
    );
    form.append("userId", info.id);
    form.append("file", info.profilepic == undefined ? "" : info.profilepic);

    // form.append("file", info.profilepic);
    sendRequest(
      "updateuser",
      form
      // {
      //   conditions: `id/=/${info.id}`,
      //   file: info.profilepic,
      //   // coverimg_fileid: info.profilepic,
      //   // isadmin,${info.isadmin}@@
      //   // type,${info.user_admin_group}@@
      //   // mobile,${info.mobile}@@
      //   // fathername,${info.fathername}@@
      //   // codemelli,${info.codemelli}@@
      //   // address,${info.address}@@
      //   // cityid,${info.cityid}@@
      //   // jender,${info.jender}@@
      //   // mtm,${info.mtm}@@
      //   // coverimg_fileid,@@
      //   // bdday,${info.bdday}@@
      //   // bdmonth,${info.bdmonth}@@
      //   // bdyear,${info.bdyear}
      //   updateValue: ``,
      // }
    )
      .then(({ data }) => {
        if (data.status == 1) {
          setUpdater(!Updater);
          showSwalSuccess("ویرایش مشخصات کاربر با موفقیت انجام شد");
        } else {
          Swal.fire("مشکلی در ویرایش مشخصات کاربر پیش آمده است", "", "warning");
        }
      })
      .catch((error) => {});
  };

  const FilterUsers = (users) => {
    let Customers = [...users];
    let Personel = [...users];
    setFilteredCustomers(
      Customers.filter((item) => item.type == 1 || item.type == 2)
    );
    setFilteredPersonel(
      Personel.filter((item) => item.type == 3 || item.type == 0)
    );
  };

  const User_Access = (id) => {};

  useEffect(() => {
    sendRequest("Find_user_tags")
      .then(({ data }) => {
        let array = [];
        data.forEach((element) => {
          array.push({ value: `${element.id}`, label: `${element.title}` });
        });
        settags(array);
      })
      .catch((error) => {});

    if (FilterKey) {
      FilterSend("iscustomer", 1, 0);
      FilterSend("isadmin", 1, 1);
    } else {
      sendRequest("fullusers", {
        iscustomer: "1",
        page: [pagination2 + 1],
        count: "10",
      })
        .then(({ data }) => {
          setFilteredCustomers(data.data);
          setCountCustomers(data.userCount);
        })
        .catch((error) => {});

      sendRequest("fullusers", {
        isadmin: "1",
        page: [pagination + 1],
        count: "10",
      })
        .then(({ data }) => {
          setFilteredPersonel(data.data);
          setCountPersonal(data.userCount);
          setLoading(false);
        })
        .catch((error) => {});
    }

    sendRequest("Find_cities")
      .then(({ data }) => {
        setCitys(data);
      })
      .catch((error) => {});
  }, [Updater]);

  const Pages = (conditions, page, isadmin) => {
    let form = new FormData();
    form.append(`${conditions}`, "1");
    form.append("page", `${page}`);
    form.append("count", "10");
    sendRequest("fullusers", form)
      .then(({ data }) => {
        if (isadmin == 1) {
          setFilteredPersonel(data.data);
          setCountPersonal(data.userCount);
        } else {
          setFilteredCustomers(data.data);
          setCountCustomers(data.userCount);
        }
      })
      .catch((error) => {});
  };

  const SendMessage = (AppendObj, people, setSendMg) => {
    if (people.length == 1) {
      if (people[0][1] == "" && AppendObj.needemail == 1) {
        showSwalError("\n کاربر مورد نظر ایمیلی ندارد");
      } else {
        const currentDate = new Date();
        const timestamp = currentDate.getTime();
        let form = new FormData();
        form.append("muid", `${auth.userInfo.id}`);
        form.append("type", "1");
        form.append("uid", `${people[0][0]}`);
        form.append("msgtxt", `${AppendObj.msgtxt}`);
        form.append("mtm", `${timestamp}`);
        form.append("needsms", `${AppendObj.needsms ? 1 : 0}`);
        form.append("needemail ", `${AppendObj.needemail ? 1 : 0}`);
        sendRequest("Insert_msgs", form)
          .then(({ data }) => {
            if (data.status) {
              showSwalSuccess("پیام ارسال شد");
              setSendMg({
                ...AppendObj,
                ["msgtxt"]: "",
                ["needsms"]: false,
                ["needemail"]: false,
              });
            } else {
              showSwalError("\n مشکلی در ارسال پیام پیش آمده است ");
              return;
            }
          })
          .catch((error) => {});
      }
    } else {
      let key = 0;
      people.some((item) => {
        if (item[1] == "" && AppendObj.needemail && key == 0) {
          key = 1;
          showSwalError("\n تعدادی از کاربران مورد نظر ایمیل ندارند");
          return false;
        }
      });
      if (key == 0) {
        key = 0;
        var Break = true;
        people.some((item) => {
          const currentDate = new Date();
          const timestamp = currentDate.getTime();
          let form = new FormData();
          form.append("muid", `${auth.userInfo.id}`);
          form.append("type", "1");
          form.append("uid", `${item[0]}`);
          form.append("msgtxt", `${AppendObj.msgtxt}`);
          form.append("mtm", `${timestamp}`);
          form.append("needsms", `${AppendObj.needsms ? 1 : 0}`);
          form.append("needemail", `${AppendObj.needemail ? 1 : 0}`);
          sendRequest("Insert_msgs", form)
            .then(({ data }) => {
              if (data.status) {
                showSwalSuccess("پیام ارسال شد");
                setSendMg({
                  ...AppendObj,
                  ["msgtxt"]: "",
                  ["needsms"]: false,
                  ["needemail"]: false,
                });
              } else {
                if (Break) {
                  Break = false;
                  showSwalError("\n  مشکلی در ارسال پیام پیش آمده است");
                }
              }
            })
            .catch(({ errors }) => {});
        });
      }
    }
  };

  const FilterSend = (conditions, page, isadmin) => {
    if (dates.length == 1) {
      showSwalError("\nلطفا دو روز را انتخاب کنید");
    } else {
      let filters = new FormData();
      let flag = 0;
      Object.keys(filter).map((item) => {
        if (filter[item] != "") {
          filters.append(`${item}`, filter[item]);
          flag = 1;
        }
      });

      if (flag == 1) {
        filters.append(`${conditions}`, "1");
        filters.append("page", `${page}`);
        filters.append("count", "10");
        sendRequest("fullusers", filters)
          .then(({ data }) => {
            flag = 0;
            // setInfo(data.data);
            // updateFilteredUsers(data.data);
            if (isadmin == 1) {
              setCountPersonal(data.userCount);
              setFilteredPersonel(data.data);
            } else {
              setCountCustomers(data.userCount);
              setFilteredCustomers(data.data);
            }
          })
          .catch((error) => {});
      } else {
        Pages("iscustomer", 1, 0);
        Pages("isadmin", 1, 1);
      }
    }
  };

  return (
    <div className="user-management-main-container">
      {loading ? <Loader /> : ""}

      <Helmet>
        <title> مدیریت کاربران</title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>

      <Modals
        chosenPeople={Tab == 1 ? chosenPersonel : chosenCustomers}
        Tab={Tab}
        Update={Update}
        changeStatus={changeStatus}
        SelectedUserInformation={SelectedUserInformation}
        EditUser={setSelectedUserInformation}
        Access={Access}
        Citys={Citys}
        UserAccess={UserAccess}
        setUserAccess={setUserAccess}
        Labels={tags}
        FirstAccess={FirstAccess}
        setUpdater={setUpdater}
        Updater={Updater}
        SendMessage={SendMessage}
      ></Modals>

      <div className="  bg-light pt-3 pb-5">
        <button
          className="btn btn-success m-3"
          id=""
          data-bs-toggle="modal"
          data-bs-target="#FilterModal"
        >
          <FaFilter /> جستجو
        </button>
        <button
          className="btn btn-danger m-3"
          id=""
          onClick={() => {
            setFilterKey(false);
            setUpdater(!Updater);
            setFilter({
              ...filter,
              ["user_type"]: "",
              ["fname"]: "",
              ["lname"]: "",
              ["mobile"]: "",
              ["codemelli"]: "",
              ["frommtm"]: "",
              ["tomtm"]: "",
              ["mainstatus"]: "",
              ["user_tags_ids"]: "",
            });
            setDates([]);
            setpagination(0);
            setpagination2(0);
          }}
        >
          <FaTrashAlt /> حذف جستجو
        </button>
        <div style={{ margin: "3%" }}>
          <UserInfoModal id={id} Updater={UpdaterModal} />

          <Filter
            updateFilteredUsers={FilterUsers}
            Labels={tags}
            Pages={Pages}
            setFilterKey={setFilterKey}
            setCountCustomers={setCountCustomers}
            setCountPersonal={setCountPersonal}
            FilterSend={FilterSend}
            setDates={setDates}
            setFilter={setFilter}
            dates={dates}
            filter={filter}
          ></Filter>

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#personnel"
                type="button"
                role="tab"
                aria-controls="personnel"
                aria-selected="true"
                onClick={() => setTab(1)}
              >
                پرسنل
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="customers-tab"
                data-bs-toggle="tab"
                data-bs-target="#customers"
                type="button"
                role="tab"
                aria-controls="customers"
                aria-selected="false"
                onClick={() => setTab(0)}
              >
                مشتریان
              </button>
            </li>
          </ul>

          <div className="tab-content " id="myTabContent">
            <PersonnelTab
              pagination={pagination}
              setpagination={setpagination}
              deleteUser={deleteUser}
              changeStatus={changeStatus}
              filteredUsers={filteredPersonel}
              setSelectedUserInformation={setSelectedUserInformation}
              setChosenPeople={setChosenPersonel}
              chosenPeople={chosenPersonel}
              Labels={tags}
              Pages={Pages}
              User_Access={User_Access}
              Updater={Updater}
              CountPersonal={countPersonal}
              FilterKey={FilterKey}
              FilterSend={FilterSend}
              setId={setId}
              setUpdaterModal={setUpdaterModal}
              UpdaterModal={UpdaterModal}
            ></PersonnelTab>

            <CustomerTab
              pagination={pagination2}
              setpagination={setpagination2}
              CountCustomers={countCustomers}
              deleteUser={deleteUser}
              changeStatus={changeStatus}
              filteredUsers={filteredCustomers}
              setSelectedUserInformation={setSelectedUserInformation}
              setChosenPeople={setChosenCustomers}
              chosenPeople={chosenCustomers}
              Labels={tags}
              Pages={Pages}
              User_Access={User_Access}
              Updater={Updater}
              FilterKey={FilterKey}
              FilterSend={FilterSend}
              setId={setId}
              setUpdaterModal={setUpdaterModal}
              UpdaterModal={UpdaterModal}
            ></CustomerTab>
          </div>
        </div>
      </div>
    </div>
  );
}
